module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_01_american-village-59a3bdf54c304b9912fc15d2656c1119.jpg";